import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import request from 'src/utils/request'

const initialState = {
  isLoading: false,
  isSuccess: false,
  statusData: [],
  error: '',
}

export const getStatusList = createAsyncThunk('status/getStatusList', async (_, thunkAPI) => {
  try {
    const token = await thunkAPI.getState().auth.user.token
    const res = await request(token).get(`/tables/status`)
    const data = await res.data
    return data
  } catch (err) {
    toast.error(err.response.data)
    return thunkAPI.rejectWithValue(err.response.data)
  }
})

export const deleteStatus = createAsyncThunk(
  'status/deleteStatus',
  async ({ childrenProps, lang }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.user.token
      const res1 = await request(token).delete(`/tables/status`, {
        data: childrenProps.selected,
      })
      const dt = await res1.data
      toast.success(
        lang === 'Français'
          ? dt?.rowDeleted + ' état(s) supprimé(s) avec succès'
          : dt?.rowDeleted + ' status deleted successfully',
      )
      const res = await request(token).get(`/tables/status`)
      const data = await res.data
      return data
    } catch (err) {
      const message =
        lang === 'Français'
          ? 'Erreur ! ' +
            err.response.data.errorCount +
            ' sur ' +
            childrenProps.selected.length +
            " état(s) n'ont pas pu être supprimés"
          : 'Error ! ' +
            err.response.data.message.errorNum +
            ' of ' +
            childrenProps.selected.length +
            ' status could not be deleted'
      toast.error(message)
      return thunkAPI.rejectWithValue(message)
    }
  },
)

export const insertStatus = createAsyncThunk(
  'status/insertStatus',
  async ({ currentStatus, lang }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.user.token
      const res1 = await request(token).post(`/tables/status`, { data: currentStatus })
      const message = lang === 'Français' ? 'Etat ajouté avec succès' : 'Status added successfully'
      toast.success(message)
      const res = await request(token).get(`/tables/status`)
      const data = await res.data
      return data
    } catch (err) {
      const message =
        lang === 'Français'
          ? 'Erreur ' + err.response.data.message.errorNum + " ! L'état n'a pas pu être ajouté"
          : 'Error ' + err.response.data.message.errorNum + ' ! The status could not be added'
      toast.error(message)
      return thunkAPI.rejectWithValue(message)
    }
  },
)

export const updateStatus = createAsyncThunk(
  'status/updateStatus',
  async ({ currentStatus, lang }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.user.token
      const res1 = await request(token).put(`/tables/status`, { data: currentStatus })
      const message =
        lang === 'Français'
          ? res1.data.rowUpdated + ' état(s) modifié(s) avec succès'
          : res1.data.rowUpdated + ' status updated successfully'
      toast.success(message)
      const res = await request(token).get(`/tables/status`)
      const data = await res.data
      return data
    } catch (err) {
      const message =
        lang === 'Français'
          ? err.response.data.rowUpdated + ' état(s) mis à jour avec succès'
          : err.response.data.rowUpdated + ' status updated successfully'
      toast.error(message)
      return thunkAPI.rejectWithValue(message)
    }
  },
)

export const statusSlice = createSlice({
  name: 'status',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStatusList.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        }
      })
      .addCase(getStatusList.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          statusData: action.payload,
          error: '',
        }
      })
      .addCase(getStatusList.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: false,
          error: action.error.message,
        }
      })
      .addCase(insertStatus.pending, (state, action) => {
        return {
          ...state,
        }
      })
      .addCase(insertStatus.fulfilled, (state, action) => {
        return {
          ...state,
          statusData: action.payload,
        }
      })
      .addCase(insertStatus.rejected, (state, action) => {
        return {
          ...state,
          isSuccess: false,
          error: action.payload,
        }
      })
      .addCase(updateStatus.pending, (state, action) => {
        return {
          ...state,
        }
      })
      .addCase(updateStatus.fulfilled, (state, action) => {
        return {
          ...state,
          statusData: action.payload,
        }
      })
      .addCase(updateStatus.rejected, (state, action) => {
        return {
          ...state,
          isSuccess: false,
          error: action.payload,
        }
      })
      .addCase(deleteStatus.pending, (state, action) => {
        return {
          ...state,
        }
      })
      .addCase(deleteStatus.fulfilled, (state, action) => {
        return {
          ...state,
          isSuccess: true,
          statusData: action.payload,
        }
      })
      .addCase(deleteStatus.rejected, (state, action) => {
        return {
          ...state,
          isSuccess: false,
          error: action.payload,
        }
      })
  },
})

export default statusSlice.reducer
